
import { Component, Prop, Vue } from 'vue-property-decorator'
import { routeToFilters } from '../../../pu-links/infrastructure/routeToFilters'

@Component
export default class SearchSummaryMain extends Vue {
  @Prop()
    isAvailabilitySearch: boolean

  @Prop()
    categoryName?: string

  @Prop()
    hierarchyName: string

  @Prop({ default: false })
    isUserLocationSearch: boolean

  @Prop()
    distance: { mi: number; km: number }

  @Prop()
    bookableCount: number

  @Prop()
    campsitesCount: number

  @Prop()
    count: number

  @Prop()
    heading: string | null

  @Prop({ required: false })
    query?: string

  @Prop({ required: false })
    placename?: string

  @Prop()
    sortOption?: string

  get searchPlace(): string | undefined {
    return this.query || this.placename || this.hierarchyName
  }

  get filters() {
    return routeToFilters(this.$route)
  }
}
